import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import AppPaths from '../../AppPaths';
import { ReactComponent as ArrowLeftIcon } from '../../assets/images/icons/arrow_left.svg';
import styles from './HardwareFirstCartHeader.module.scss';

/**
 * The hardware-first cart's page title, a back link to the shop at both widths. Going back
 * through history instead would land on whatever preceded the cart - a stale url, a pdp, or the
 * checkout - rather than somewhere to keep shopping. `/shop` redirects anyone outside the arm to
 * `/products`, so this is safe either way.
 */
export default function HardwareFirstCartHeader() {
  const { t } = useTranslation();
  const history = useHistory();

  const leaveCart = () => history.push(AppPaths.Shop);

  return (
    <>
      <button className={styles.mobileHeader} onClick={leaveCart} type="button">
        <ArrowLeftIcon className={styles.backArrow} />
        <span className={styles.mobileTitle}>{t('cart')}</span>
      </button>
      <div className={styles.desktopHeaderRow}>
        <button className={styles.desktopHeader} onClick={leaveCart} type="button">
          <ArrowLeftIcon className={styles.backArrow} />
          <span className={styles.desktopTitle}>{t('cart')}</span>
        </button>
      </div>
    </>
  );
}
